import { ca } from "date-fns/locale";
import OnboardingType from "../../../../../shared/onboarding/onboarding-type";
import overview from "../../../../icons/overview";
import { UPLOAD_SHOTS, UPLOAD_SHOTS_CLEAR_REDIRECT, UPLOAD_SHOTS_CLEAR_WARNINGS } from "./actions";

interface CharacterOverviewState {
  loading: boolean;
  readOnly: boolean;
  errors: any;
  shotsOnboardingSteps: OnboardingType[];
  isUploading: boolean;
  redirect: any;
  missingHeaders?: string[];
  unexpectedHeaders?: string[];
  shotRowIssues: any[];
}

export const OnboardingStep1ClassName = 'shots-overview-onboarding-step-1';
export const OnboardingStep2ClassName = 'shots-overview-onboarding-step-2';
export const OnboardingStep3ClassName = 'shots-overview-onboarding-step-3';
export const OnboardingStep4ClassName = 'shots-overview-onboarding-step-4';

const defaultState: CharacterOverviewState = {
  loading: false,
  readOnly: false,
  isUploading: false,
  errors: null,
  redirect: null,
  shotRowIssues: [],
  shotsOnboardingSteps: [
    {
      target: '.' + OnboardingStep1ClassName,
      title: 'Upload',
      content: `<p>The CSV or Excel file should contain columns for Number, Size, Focal Length, Frame Rate and Movements etc. Please download example file to see all the headers.</p>
      <p>The file can contain shots for other scenes.</p>
      <p>If the shot number already exists in the scene, the existing shot will be updated with the contents of the file.</p>
      <p>If the shot number does not exist in the scene, a new shot will be created.</p>
      <p>Warnings will be returned for any missing or unexpected headers, but the file will still be imported.</p>`
    }
  ]
};

const reducer = (state = defaultState, action: any = {}) => {
  switch (action.type) {

    case UPLOAD_SHOTS + "_PENDING": {
      return {
        ...state,
        loading: true,
        isUploading: true,
        errors: null,
        warnings: null,
        missingHeaders: null,
        unexpectedHeaders: null,
        shotRowIssues: []
      };
    }

    case UPLOAD_SHOTS + "_FULFILLED": {
      const shouldRedirect = action.payload.data.missingHeaders &&
        action.payload.data.missingHeaders.length === 0 &&
        action.payload.data.unexpectedHeaders &&
        action.payload.data.unexpectedHeaders.length === 0 &&
        action.payload.data.shotRowIssues &&
        action.payload.data.shotRowIssues.length === 0;      
      return {
        ...state,
        actors: action.payload.data.actors,
        readOnly: action.payload.data.readOnly,
        loading: false,
        isUploading: false,
        errors: null,
        warnings: action.payload.data.warnings,
        missingHeaders: action.payload.data.missingHeaders,
        unexpectedHeaders: action.payload.data.unexpectedHeaders,
        shotRowIssues: action.payload.data.shotRowIssues,
        redirect: shouldRedirect ? { to: "list" } : null
      };
    }

    case UPLOAD_SHOTS + "_REJECTED": {
      return {
        ...state,
        loading: false,
        isUploading: false,
        errors: action.payload.response.data.errors,
        warnings: action.payload.response.data.warnings,
        missingHeaders: action.payload.response.data.missingHeaders,
        unexpectedHeaders: action.payload.response.data.unexpectedHeaders,
        shotRowIssues: action.payload.response.data.shotRowIssues
      };
    }

    case UPLOAD_SHOTS_CLEAR_WARNINGS: {
      return {
        ...state,
        errors: null,
        warnings: null,
        missingHeaders: null,
        unexpectedHeaders: null,
        shotRowIssues: []
      };
    }

    case UPLOAD_SHOTS_CLEAR_REDIRECT: {
      return {
        ...state,
        redirect: null
      };
    }

    default:
      return state;
  }
};

export default reducer;
